export enum DevicesWidth {
  XS = 400,
  SM = 600,
  XSM = 768,
  MD = 900,
  XMD = 1024,
  LG = 1200,
  XL = 1536,
}
